import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
// Intentionally empty — placeholder landing page inside the portal shell.
export default function Home() {
    return (_jsxs("div", { className: "flex min-h-screen", style: { background: '#F3F5EF' }, children: [_jsx(Sidebar, {}), _jsxs("div", { className: "flex-1 flex flex-col", children: [_jsx(Navbar, {}), _jsx("main", { className: "p-4 mt-20 w-full" })] })] }));
}
